import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      "home": "Home",
      "services": "Services",
      "approach": "Method",
      "contact": "Contact",
      "talk_to_us": "Talk to us",
      "open_menu": "Open menu",
      "close_menu": "Close menu",
      "hero_eyebrow": "Technical consulting for internet service providers",
      "hero_lead": "Network design, operations support, and troubleshooting for ISPs that need to grow with stability, security, and predictability.",
      "hero_cta": "Discuss your network",
      "hero_metrics_label": "L3 Route consulting focus areas",
      "metric_one_value": "ISP networks",
      "metric_one_label": "routing, access, and transport",
      "metric_two_value": "Operations",
      "metric_two_label": "monitoring, changes, and documentation",
      "metric_three_value": "Critical events",
      "metric_three_label": "structured diagnosis and response",
      "services_eyebrow": "Where we help",
      "services_title": "Technical consulting for provider operations",
      "services_subtitle": "From planning to incident response, L3 Route works beside your team to reduce risk, improve visibility, and keep the network ready for growth.",
      "service_monitoring_title": "Network monitoring",
      "service_monitoring_description": "Indicators, alerts, and dashboards focused on availability, capacity, latency, and recurring failure patterns.",
      "service_monitoring_alt": "Network rack with structured cabling",
      "service_consulting_title": "Monthly consulting",
      "service_consulting_description": "Recurring technical guidance for changes, documentation, capacity planning, and operational decisions.",
      "service_consulting_alt": "Network equipment in a datacenter",
      "service_vpn_title": "VPN and secure access",
      "service_vpn_description": "Site-to-site connectivity, remote access, segmentation, and hardening for internal and customer-facing environments.",
      "service_vpn_alt": "Server rack in a technical room",
      "service_mikrotik_title": "MikroTik configuration",
      "service_mikrotik_description": "Routing, firewall, QoS, addressing, automation, and configuration review for stable ISP environments.",
      "service_mikrotik_alt": "Network router and cables",
      "service_olt_title": "OLT configuration",
      "service_olt_description": "Review and configuration of OLTs, VLANs, service profiles, access policies, and last-mile troubleshooting.",
      "service_olt_alt": "OLT equipment in a telecom rack",
      "service_incidents_title": "Problem solving",
      "service_incidents_description": "Investigation of outages, packet loss, loops, routing issues, and recurring failures with a clear action plan.",
      "service_incidents_alt": "Datacenter corridor with network cabinets",
      "approach_eyebrow": "Consulting method",
      "approach_title": "Calm diagnosis before action",
      "approach_subtitle": "Serious network work starts with context. We map the environment, separate symptoms from causes, and define changes that your team can operate after delivery.",
      "approach_step_one_title": "Understand the environment",
      "approach_step_one_text": "Topology, equipment, routes, services, monitoring, and the operational constraints around the network.",
      "approach_step_two_title": "Prioritize what matters",
      "approach_step_two_text": "Risks, bottlenecks, urgent incidents, and improvements are organized into a practical technical roadmap.",
      "approach_step_three_title": "Deliver and support",
      "approach_step_three_text": "Configuration, validation, documentation, and follow-up so the operation keeps moving with confidence.",
      "contact_eyebrow": "Next step",
      "contact_title": "Let’s talk about your operation",
      "contact_text": "Send your current scenario, the symptoms you are seeing, or the project you need to plan.",
      "contact_note": "Consulting is provided remotely only, with meetings, technical analysis, configuration guidance, and follow-up through online channels.",
      "contact_email": "contact@l3route.com",
      "footer_text": "Independent consulting for internet providers and critical network operations.",
    }
  },
  "pt-BR": {
    translation: {
      "home": "Início",
      "services": "Serviços",
      "approach": "Método",
      "contact": "Contato",
      "talk_to_us": "Fale conosco",
      "open_menu": "Abrir menu",
      "close_menu": "Fechar menu",
      "hero_eyebrow": "Consultoria técnica para provedores de internet",
      "hero_lead": "Projetos, sustentação e troubleshooting para redes que precisam crescer com estabilidade, segurança e previsibilidade.",
      "hero_cta": "Conversar sobre a rede",
      "hero_metrics_label": "Áreas de atuação da consultoria L3 Route",
      "metric_one_value": "Redes ISP",
      "metric_one_label": "roteamento, acesso e transporte",
      "metric_two_value": "Operação",
      "metric_two_label": "monitoramento, mudanças e documentação",
      "metric_three_value": "Eventos críticos",
      "metric_three_label": "diagnóstico e resposta estruturada",
      "services_eyebrow": "Onde atuamos",
      "services_title": "Consultoria técnica para a operação do provedor",
      "services_subtitle": "Do planejamento à resposta a incidentes, a L3 Route trabalha junto ao seu time para reduzir risco, melhorar visibilidade e preparar a rede para crescer.",
      "service_monitoring_title": "Monitoramento de rede",
      "service_monitoring_description": "Indicadores, alertas e painéis focados em disponibilidade, capacidade, latência e padrões de falha recorrentes.",
      "service_monitoring_alt": "Rack de rede com cabeamento estruturado",
      "service_consulting_title": "Consultoria mensal",
      "service_consulting_description": "Acompanhamento técnico recorrente para mudanças, documentação, planejamento de capacidade e decisões operacionais.",
      "service_consulting_alt": "Equipamentos de rede em datacenter",
      "service_vpn_title": "VPN e acesso seguro",
      "service_vpn_description": "Conectividade site-to-site, acesso remoto, segmentação e hardening para ambientes internos e de clientes.",
      "service_vpn_alt": "Rack de servidores em sala técnica",
      "service_mikrotik_title": "Configuração MikroTik",
      "service_mikrotik_description": "Roteamento, firewall, QoS, endereçamento, automação e revisão de configuração para ambientes ISP estáveis.",
      "service_mikrotik_alt": "Roteador de rede com cabos",
      "service_olt_title": "Configuração de OLT",
      "service_olt_description": "Revisão e configuração de OLTs, VLANs, perfis de serviço, políticas de acesso e troubleshooting de última milha.",
      "service_olt_alt": "Equipamento OLT em rack de telecom",
      "service_incidents_title": "Resolução de problemas",
      "service_incidents_description": "Investigação de indisponibilidade, perda de pacotes, loops, falhas de roteamento e problemas recorrentes com plano de ação claro.",
      "service_incidents_alt": "Corredor de datacenter com gabinetes de rede",
      "approach_eyebrow": "Método consultivo",
      "approach_title": "Diagnóstico calmo antes da mudança",
      "approach_subtitle": "Trabalho sério em rede começa por contexto. Mapeamos o ambiente, separamos sintomas de causas e definimos mudanças que seu time consegue operar depois da entrega.",
      "approach_step_one_title": "Entender o ambiente",
      "approach_step_one_text": "Topologia, equipamentos, rotas, serviços, monitoramento e as restrições operacionais ao redor da rede.",
      "approach_step_two_title": "Priorizar o que importa",
      "approach_step_two_text": "Riscos, gargalos, incidentes urgentes e melhorias entram em um roteiro técnico viável para a operação.",
      "approach_step_three_title": "Entregar e acompanhar",
      "approach_step_three_text": "Configuração, validação, documentação e acompanhamento para que a operação siga com confiança.",
      "contact_eyebrow": "Próximo passo",
      "contact_title": "Vamos falar sobre sua operação",
      "contact_text": "Envie o cenário atual, os sintomas que você está vendo ou o projeto que precisa planejar.",
      "contact_note": "Atuação somente remota, com reuniões, análise técnica, orientação de configuração e acompanhamento por canais online.",
      "contact_email": "contato@l3route.com",
      "footer_text": "Consultoria independente para provedores de internet e operações críticas de rede.",
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "en"],
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
